<template>
  <div class="submit-container">
    <div
      class="cart-guide-tip j-click-use-cart-guide"
      v-if="showUseCartGuideTip"
      @click="handleUseCartGuide"
    >
      <span class="cart-guide-tip-ico"></span>{{ letter.cartGuideTipNew }}
      <div class="cart-guide-tip-btn"></div>
    </div>
    <div class="detail-container" :class="{ coupon: +curPayType.coupon }">
      <div class="order-detail">
        <div class="order-detail-title" v-if="!isGsOrSupPayAutoSelect">
          <!-- 江美特殊处理，商品名称是个图片 -->
          <template v-if="gameId == 2">
            <p class="product-name">
              {{ letter.storeHasSelect }}：
              <img
                class="product-name-img"
                :src="getBeautyNameIco(curProduct.PRODUCT_ICON)"
                :alt="curProduct.PRODUCT_ICON"
                @error="beautyNameIcoError($event, curProduct.PRODUCT_ICON)"
              />
            </p>
          </template>
          <template v-else>
            {{ letter.storeHasSelect }}：{{ getProductName(curProduct) }}
          </template>
          <template v-if="curPriceSubCoin">
            <span style="margin: 0 5px">+</span>{{ curPriceSubCoin
            }}<span style="margin: 0 5px">{{ subCoinNama }}</span>
          </template>
        </div>
        <div class="order-detail-other">
          <div class="order-detail-price">
            <p class="discount-price" v-if="curPayType.coupon">
              <span>{{ letter.storeTotal }}：</span>
              <span class="price-wrap">
                <span class="discount-total"
                  >{{ discountTransMount }}
                  {{ curPayType ? curPayType.show_currency : '' }}</span
                >
                <span class="price-total" v-if="paytypeActiveCouponId"
                  >{{ transMount }}
                  {{ curPayType ? curPayType.show_currency : '' }}</span
                >
              </span>
              <!-- 美国且非代币才显示税费 -->
              <span v-if="isShowTax">
                {{
                  `+${curTax}${curPayType ? curPayType.show_currency : ''}(tax)`
                }}
              </span>
            </p>
            <p class="price" v-else>
              {{ letter.storeTotal }}：
              <span class="price-total"
                >{{ transMount }}
                {{ curPayType ? curPayType.show_currency : '' }}</span
              >
              <span v-if="isShowTax">
                {{
                  `+${curTax}${curPayType ? curPayType.show_currency : ''}(tax)`
                }}
              </span>
            </p>
            <span
              class="extra"
              v-if="
                (curPriceExtraCoin || curProduct.PRODUCT_EXTRA_COIN) &&
                !isGsOrSupPayAutoSelect
              "
              >{{ letter.storeExtra }}：

              <template v-if="+curProduct.PRODUCT_EXTRA_COIN">
                {{ curProduct.PRODUCT_EXTRA_COIN
                }}<span style="margin: 0 5px">{{ coin_name }}</span>
              </template>
              <template v-if="+curPriceExtraCoin">
                <template v-if="+curProduct.PRODUCT_EXTRA_COIN"
                  ><span style="margin: 0 5px">+</span></template
                >
                {{ curPriceExtraCoin
                }}<span style="margin: 0 5px">{{ extraCoinName }}</span>
              </template>
            </span>
          </div>
          <div class="order-detail-right">
            <div
              class="order-coupon j-select-coupon-entry"
              v-if="+curPayType.coupon === 1"
            >
              <div
                class="order-coupon-choose"
                :class="{ highlight: !paytypeActiveCouponId }"
                @click="showPaytypeCouponPopup"
              >
                <template v-if="!paytypeActiveCouponId">
                  <p class="order-coupon-choose-text highligh">
                    {{ letter.couponHasNoSelect }}
                  </p>
                  <p class="order-coupon-choose-text highligh">
                    {{
                      letter.couponValidQuanTip.replace(
                        '${num}',
                        paytypeEnableCouponList.length
                      )
                    }}
                  </p>
                </template>
                <p
                  class="order-coupon-choose-text"
                  v-else-if="activePaytypeCouponFullReductType"
                >
                  {{ letter.couponHasSelectQuan }}：{{
                    activePaytypeCouponReductionName
                  }}
                </p>
                <p class="order-coupon-choose-text" v-else>
                  {{ letter.couponHasSelectQuan }}：{{
                    activePaytypeCouponDiscountName
                  }}
                </p>
              </div>
              <p class="order-coupon-tip" v-if="paytypeActiveCouponId">
                {{ letter.couponSubmitTip }}
              </p>
            </div>
            <Button
              class="submit-btn normal-btn j-submit-nbtn"
              @click="postOrder"
              pointClass="j-submit-dcount j-submit-nbtn"
              :loading="submitLoading"
            >
              {{ submitOrderBtnText }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import coupon from '@mixins/officialStore/coupon';
import propImg from '@mixins/officialStore/propImg';
import pay from '@mixins/officialStore/pay';
import zipcode from '@mixins/officialStore/zipcode';
import { mapGetters, mapState } from 'vuex';
import product from '@mixins/product';
import gsOperate from '@mixins/officialStore/gsOperate';
export default {
  name: 'SubmitFooter',
  mixins: [coupon, propImg, pay, zipcode, product, gsOperate],
  props: [
    'curPayType',
    'curProduct',
    'curPriceSubCoin',
    'coin_name',
    'submitLoading',
    'discountTransMount',
    'transMount',
    'curPriceExtraCoin'
  ],
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      isUidLogin: state => state.login.isUidLogin,
      curLocation: state => state.curLocation,
      zipCode: state => state.zipCode,
      curTax: state => state.curTax
    }),
    ...mapGetters([
      'getPointPayChannelName',
      'isJpPlatform',
      'subCoinNama',
      'extraCoinName',
      'directPayCoinName',
      'directPayExtraCoinName'
    ]),
    submitOrderBtnText() {
      if (
        this.curPayType &&
        this.curPayType.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.isJpPlatform
          ? this.letter.jpUidLoginName
          : this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    },
    isShowTax() {
      return (
        +this.curTax > 0 &&
        this.curLocation === 'US' &&
        this.curPayType.pay_type !== 'user_balance_pay'
      );
    },
    getRefreshTax() {
      const { curLocation, discountTransMount, zipCode } = this;
      return {
        curLocation,
        discountTransMount,
        zipCode
      };
    }
  },
  watch: {
    getRefreshTax: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (
          newVal.curLocation === 'US' &&
          newVal.discountTransMount &&
          newVal.zipCode &&
          this.curPayType.show_currency === 'USD'
        ) {
          this.getCurrentTax({
            zipCode: newVal.zipCode,
            amount: newVal.discountTransMount,
            currency: this.curPayType.show_currency
          });
        }
      }
    }
  },
  methods: {
    postOrder() {
      this.$emit('postOrder');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.submit-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  box-sizing: border-box;
  padding: 0 36px;
  width: 100%;
  background: var(--submit-bg);
  font-size: 0;
}
.cart-guide-tip {
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  top: -50px;
  width: 100%;
  height: 50px;
  font-size: 22px;
  background-color: #e5d9cc;
  border: solid 2px #bca892;
  color: #906d1d;
  box-sizing: border-box;
  font-weight: bold;
  cursor: pointer;
  &-ico {
    position: relative;
    margin: 0 5px 0 16px;
    @psetbg ('cart-guide-ico.png');
  }
  &-btn {
    position: absolute;
    right: 27px;
    top: 50%;
    transform: translateY(-50%);
    @psetbg ('cart-guide-btn.png');
  }
}
.detail-container {
  display: block;
  float: left;
  position: relative;
  box-sizing: border-box;
  padding: 22px 0;
  width: 100%;
  height: 180px;
  &.coupon {
    height: 236px;
  }
}

.order-detail {
  &-title {
    font-size: 24px;
    color: var(--submit-title);
    .product-name {
      display: inline-block;
    }
  }
  &-other {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .order-detail-price {
      font-size: 30px;
      color: var(--submit-discount);
      .discount-price {
        display: flex;
        font-weight: bold;
        align-items: end;
        .price-wrap {
          display: flex;
          flex-direction: column;
        }
        .discount-total {
          font-size: 41px;
        }
        .price-total {
          text-decoration: line-through;
          text-decoration-color: var(--submit-price-hua);
          font-size: 24px;
          color: var(--submit-price);
        }
      }
      .price {
        font-weight: bold;
        .price-total {
          font-size: 41px;
        }
      }
      .paytype-tip {
        margin-top: 10px;
        font-size: 20px;
        color: var(--submit-tip);
      }
      .extra {
        display: inline-block;
        margin-top: 10px;
        padding: 5px 10px;
        border: 1px solid var(--submit-extra-border);
        text-align: center;
        font-size: 20px;
        color: var(--submit-extra);
      }
    }
    .order-detail-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      .order-coupon {
        &-choose {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          padding: 5px 10px;
          border: 1px solid var(--submit-coupon-choose-border);
          font-size: 24px;
          color: var(--submit-coupon-choose);
          &-text {
            line-height: 30px;
          }
        }
        &-tip {
          margin-bottom: 15px;
          font-size: 20px;
          color: var(--submit-tip);
        }
        .highligh {
          color: var(--submit-coupon-unchoose);
        }
      }
      .submit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        cursor: pointer;
        font-size: 24px;
        color: var(--submit-btn);
        @psetbg ('submit.png');
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .submit-container {
    left: 50%;
    width: 1202px;
    transform: translateX(-50%);
  }
  .order-detail-other .order-detail-right .submit-btn {
    cursor: pointer;
    @psetbg ('submit-hen.png');
  }
}
</style>
